/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * My App
 * This is an awesome app!
 * OpenAPI spec version: 1.0.0
 */

/**
 * The status of the contract
 */
export enum FetchContractResponseStatus {
  new= 'new',
  offer_sent= 'offer_sent',
  offer_expired= 'offer_expired',
  active= 'active',
  ended= 'ended',
  cancelled= 'cancelled',

}